
/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    var variant = event.detail.variant;
    var container = event.target;

    if (variant) {
      // support for multiple variant switchers on same page
      const updateAllAtcForms = () => {
        // dropdowns 
        if (container.querySelector('input[name="id"]') !== undefined) {
          // variant ID
          const newVariantId = container.querySelector('input[name="id"]')?.value;
          const variantInputsAll = document.querySelectorAll('input[name="id"]');
          const faveButtonsAll = document.querySelectorAll('button.swym-add-to-wishlist');
          
          // variant name
          const variantSelectButton = container.querySelector('button.select-popout__toggle');
          const variantSelectButtonsAll = document.querySelectorAll('button.select-popout__toggle');
          const swapperTarget = document.querySelector('fieldset span[data-swapper-target]');
          const radioButtons = document.querySelectorAll('fieldset.radio__fieldset label span');
          const newVariantTitle = (
            container.querySelector('input[data-single-option-selector]')?.value || 
            document.querySelector('.radio__fieldset .radio__button input:checked ~ label span').innerText
          );
  
          // update variant ID in other forms
          for (let input of variantInputsAll) {
            input.value = newVariantId;
          }
  
          // update all fave buttons with new variant ID
          for (let button of faveButtonsAll) {
            button.dataset.variantId = newVariantId;
          }
  
          // update all dropdown inputs with name of current variant
          for (let button of variantSelectButtonsAll) {
            if (button !== variantSelectButton) {
              button.innerText = newVariantTitle;
            }
          }

          // update main variant selector
          swapperTarget.innerText = newVariantTitle;
          for (let button of radioButtons) {
            if (button.innerText === newVariantTitle.toUpperCase()) {
              button.parentElement.previousElementSibling.checked = true;
            }
          }
        }

        // refresh favorites buttons
        _swat.initializeActionButtons('body');
      };

      updateAllAtcForms();
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      removeEnrollmentProducts();
      console.log("Cart ———————————— ↓");
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });

  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (e) => {
    removeEnrollmentProducts();
    console.log("theme:cart:init");
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener("theme:resize", (e) => {
    console.log(e);
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
